// Datos de Repositorio de PHP
let URL_BACK = 'https://apiback.presenciaonline.com.mx/tbt'
export {
    URL_BACK,
    
}
